<template>
  <div class="ll-link">
    <a class="link" @click.stop="$_onClick">
      <span class="ll-link__text">
        {{ textLabel }}
      </span>
      <i class="icon-link ll-link__icon" />
    </a>
  </div>
</template>
<script>
export default {
  name: 'LlLink',
  props: {
    textLabel: {
      type: String,
      default: '',
    },
    trailingIcon: {
      type: String,
      default: '',
    },
    linkHref: {
      type: String,
      default: '',
    },
  },
  methods: {
    $_onClick() {
      this.$emit('click');
    },
  },
};
</script>
<style lang="scss" scoped>
.ll-link {
  @include auto_margin_top(8px);
  @include flex_align;
  font-size: 1rem;
  line-height: 1.38;
  letter-spacing: 1px;
  color: var(--blue-500);
  .link {
    cursor: pointer;
    .ll-link__text {
      vertical-align: middle;
    }
    .ll-link__icon {
      vertical-align: middle;
      display: inline-block;
      color: var(--blue-500);
      font-size: 1.25rem;
    }
  }
}
</style>
